<template>
  <modal
    id="weekNotice"
    ref="modalv5"
    size="xl"
    dialog-class="tw-max-w-[100%] lg:tw-max-w-[1240px] tw-m-0 md:tw-mx-auto md:tw-my-0"
    content-class="ten-week-modal tw-h-[100vh] xl:tw-h-[90vh] md:tw-mt-0 lg:tw-mt-0"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="tw-flex tw-flex-col tw-justify-between tw-items-center tw-w-full tw-h-full">
      <div class="tw-w-full">
        <div
          class="tw-mt-3 tw-mx-5 tw-mb-[64px] md:tw-mb-[90px] tw-flex tw-justify-between "
        >
          <div>
            <button
              v-if="!isComplete"
              class="tw-bg-transparent tw-border-none"
              @click="getPreviousFollowUpQuestion"
            >
              <img
                class="tw-w-[24px] md:tw-w-[32px]"
                src="@/assets/images/small_back_arrow_black.svg"
              >
            </button>
          </div>
          <div class="d-flex justify-content-center">
            <img
              class="d-none d-md-block"
              src="@/assets/images/logo_black.svg"
              alt=""
            >
            <img
              class="d-block d-md-none"
              src="@/assets/images/logo_black.svg"
              width="120"
              alt=""
            >
          </div>
          <!-- dont remove this -->
          <div></div>
        </div>
        <div
          v-if="loadingMessage"
          class="tw-flex tw-flex-col tw-items-center tw-w-full justify-content-center tw-mt-[50px]"
        >
          <BSkeleton class="tw-inline tw-gap-4 tw-w-[70px] tw-m-5" />
          <BSkeleton class="tw-inline tw-gap-4 tw-w-[400px]" />
          <BSkeleton class="tw-inline tw-gap-4 tw-w-[350px]" />
          <BSkeleton class="tw-inline tw-gap-4 tw-w-[340px]" />
        </div>
        <div
          v-else
          class="tw-items-center"
        >
          <div class="tw-min-h-[40px] tw-my-5">
            <SnackbarDiscount
              v-if="showDiscountBadge && couponId"
              :code="couponId.replace(/^st_/, '')"
              :status="discountStatus"
              :loading="loadingApplyCoupon"
              :error-message="errorMessage"
            />
          </div>
          <div v-if="loadingQuestions">
            <loading
              :is-full-page="false"
              style="position: absolute; height: 100%; width: 100%"
              :active="loadingQuestions"
              color="#a783ff"
            />
          </div>
          <template v-else>
            <div
              v-if="isComplete"
              class="tw-flex tw-flex-col tw-items-center"
            >
              <PatientDoctorAssignment
                :doctor-name="getDoctorName"
                :message="followUpType === 'nothing'? followUpMessage[0].title: null"
                :url="getMemberProfileUrl"
                :loading="loadingMembers"
              />
              <b-row
                align-v="center"
                align-h="center"
                class="mt-3 mb-3 mx-auto"
              >
                <b-col
                  cols="auto"
                  class="tw-bg-slate-50 p-4"
                >
                  <span
                    class="question-title-v2"
                    style="font-size: 1.2rem"
                  >How would you rate your Winona experience so far?</span>
                  <div class="mt-3 tw-flex tw-justify-center tw-flex-wrap tw-gap-y-2">
                    <b-button
                      v-for="i in 10"
                      :key="i"
                      variant="outline-info slight-rounded mr-2"
                      :pressed="selectedRating === i"
                      @click="selectedRating = i"
                    >
                      {{ i }}
                    </b-button>
                  </div>
                </b-col>
              </b-row>
              <button
                class="tw-w-[300px] tw-rounded-lg tw-p-2 tw-uppercase tw-font-bold tw-tracking-[0.15rem] tw-bg-[#a783ff] tw-text-white"
                @click="submitNPS"
              >
                CONTINUE
              </button>
            </div>
            <div v-else>
              <div
                v-if="!followUpMessage.length"
                class="tw-flex tw-justify-center"
              >
                <h2>{{ followUpMessageError }}</h2>
              </div>
              <template v-else>
                <WeekNone
                  v-if="followUpType == 'nothing'"
                  :question="followUpMessage[0]"
                  :composite="composite"
                  @submitAnswer="answerQuestion"
                />
                <WeekSingle
                  v-if="followUpType == 'single' || followUpType == 'array'"
                  :question="followUpMessage[0]"
                  :composite="composite"
                  :last-answer="lastAnswer"
                  @submitAnswer="answerQuestion"
                />
                <WeekText
                  v-if="followUpType == 'text'"
                  :question="followUpMessage[0]"
                  :composite="composite"
                  @submitAnswer="answerQuestion"
                />

                <!-- Composites -->
                <div
                  v-if="composite"
                  class="mt-4"
                >
                  <WeekText
                    v-if="
                      composite &&
                        secondQuestionBody.answertype == 'text' &&
                        followUpMessage[1]?.requiredifvalue == firstAnswer
                    "
                    :question="secondQuestionBody"
                    @submitAnswer="answerQuestion"
                  />
                </div>
                <template v-else>
                </template>
              </template>
            </div>
          </template>
        </div>
      </div>
      <div class="tw-flex tw-items-center">
        <b class="tw-mb-[3rem]">Treatment Review</b>
      </div>
    </div>
  </modal>
</template>

<script>
import WeekSingle from '@/components/10week/WeekSingle.vue';
import WeekText from '@/components/10week/WeekText.vue';
import WeekNone from '@/components/10week/WeekNone.vue';
import SnackbarDiscount from '@/components/FollowUpDiscountCodeSystem/SnackbarDiscount.vue';
import { ChatService } from '@/services/chat.service';
import { PatientService } from '@/services/patient.service';
import { AnalyticsService } from '@/services/analytics.service';
import PatientDoctorAssignment from '@/components/FollowUpDiscountCodeSystem/PatientDoctorAssignment.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from 'vuex';
export default {
  components: {
    Loading,
    PatientDoctorAssignment,
    SnackbarDiscount, WeekNone, WeekText, WeekSingle,
  },
  data() {
    return {
      followUpMessage: [],
      followUpAnswers: [],
      conversationmemberlist: [],
      errorMessage: null,
      followUpMessageError: null,
      messages: [],
      followUpType: 'treatment',
      composite: false,
      secondQuestionBody: {},
      firstAnswer: '',
      showDiscountBadge: false,
      loadingMembers: true,
      loadingMessage: true,
      loadingQuestions: false,
      loadingApplyCoupon: false,
      discountStatus: 'pending',
      currentFollowupStep: 0,
      userId: localStorage.getItem('userid'),
      selectedRating: null,
    };
  },
  computed: {
    isComplete(){
      return this.currentFollowupStep === -1 ||
        this.messages.every(message=> message.actionstatus === 'ANSWERED') ||
        this.followUpMessage.some(message=> message.type === 'exitmodal')
    },
    getDoctorName() {
      if (this.isComplete && this.followUpType === 'nothing'){
        return `Dr. ${this.followUpMessage[0].doctor.firstname} ${this.followUpMessage[0].doctor.lastname}`;
      }
      const member = this.conversationmemberlist.find(x => x.userid === this.userId);
      if (member?.doctorname) {
        return `Dr. ${member.doctorname}`;
      } else {
        return '';
      }
    },
    getDoctorID() {
      const member = this.conversationmemberlist.find(x => x.userid === this.userId);
      if (member?.doctorid) {
        return member.doctorid;
      } else {
        return null;
      }
    },
    getMemberProfileUrl() {
      if (this.isComplete && this.followUpType === 'nothing'){
        return this.followUpMessage[0].doctor.profileUrl;
      }
      const member = this.conversationmemberlist.find(x => x.userid === this.getDoctorID);
      if (member) {
        return member.profileUrl;
      } else {
        return '';
      }
    },
    couponId(){
      return this.user.hasOwnProperty('followup_code')
        ? this.user.followup_code
        : this.$route?.query?.fud;
    },
    lastAnswer(){
      return this.followUpAnswers.length ? [...this.followUpAnswers].pop() : this.followUpMessage[0]
    },
    ...mapGetters({
      user: 'user/getUser',
    }),

  },
  watch: {
    followUpMessage() {
      if (this.followUpMessage.length > 0) {
        if (
          ['symptom', 'sideeffect'].includes(
            this.followUpMessage[0]?.treatmentoption
          )
        ) {
          this.followUpType = 'symptoms';
        } else if (
          ['recommendation', 'methodchange_recommendation'].includes(
            this.followUpMessage[0]?.answerlookup
          )
        ) {
          this.followUpType = 'treatmentform';
        } else {
          this.followUpType = this.followUpMessage[0].answertype;
        }
      }
    },
    async isComplete( isComplete ){
      if (isComplete && this.followupIdCheck && this.couponId) {
        await this.applyCoupon();
      }
    },
  },
  methods: {
    async getConversation() {
      try {
        const { data: conversation } = await ChatService.listConversation();
        this.conversation = conversation[0];
        const conversationData = await ChatService.getConversation(
          conversation[0]?.id
        );
        await this.listMessage(conversationData.data.id)
        await this.checkFollowupId();
      } catch (error) {
        console.log(error.message);
      }
    },
    async getListConversationMembers(){
      try {
        this.loadingMembers = true
        await ChatService.listConversationMember(this.conversationId)
          .then(({ data: members }) => {
            this.conversationmemberlist = members;
          }).finally(()=>{
            this.loadingMembers = false
          })
      } catch (error){
        console.error(error)
      }
    },
    async listMessage(conversationid) {
      try {
        this.nextPage = null;
        this.conversationId = conversationid;
        this.loadingMessage = true;
        const { data: messages } = await ChatService.listMessage(
          conversationid,
          this.nextPage
        );
        this.messages = messages.items.filter(message => message.type === 'prescription_followup')
        this.nextPage = messages.nextpage;
        this.followUpID = this.messages[0].id;
        await this.setFollowUpMessage(this.followUpID)
        this.loadingMessage = false;
        await this.getListConversationMembers()
      } catch (error) {
        console.log(error.message);
      }
    },
    async checkFollowupId() {
      if (this.user?.fullycancelled) return;
      try {
        const showModal = () => this.$refs.modalv5.$children[0].show();
        const { data } = await PatientService.getPatientFollowUpCheck();
        this.followupIdCheck = data.id;
        this.showDiscountBadge = data.followupstatus?.toUpperCase() === 'SENT';
        if (this.followupIdCheck) {
          showModal();
          this.claimCoupon()
        }
      } catch (error) {
        console.error(error);
      }
    },
    async claimCoupon(){
      try {
        await PatientService.patientClaimCoupon(this.followupIdCheck, { code: this.couponId });
      } catch (error) {
        console.error(error);
      }
    },
    async applyCoupon(){
      try {
        this.loadingApplyCoupon = true
        await PatientService.patientApplyCoupon(this.followupIdCheck, { code: this.couponId });
        this.discountStatus = 'success'
      } catch (error){
        this.errorMessage = error.message;
        this.discountStatus = 'error'
      }
      finally {
        this.loadingApplyCoupon = false
      }
    },
    async getFollowUpQuestion(messageId, step) {
      return ChatService.getFollowUpQuestion(messageId, step).catch(e=>{
        this.followUpMessageError = e
      });
    },
    async answerFollowUpQuestion(messageID, rootID, payload) {
      return ChatService.answerFollowUpQuestion(messageID, rootID, payload);
    },
    async setFollowUpMessage(messageid, step = 1) {
      this.composite = false;
      try {
        const followup = await this.getFollowUpQuestion(messageid, step);
        if (
          ['recommendation', 'methodchange_recommendation'].includes(
            followup.data?.[0]?.answerlookup
          ) &&
          followup.data?.[0]?.answerlist.length === 0
        ) {
          this.answerQuestion(
            followup.data?.[0]?.id,
            [],
            followup.data?.[0]
          );
          return;
        }

        if (followup.data) {
          const fmessage = this.messages.find(x => x.id === messageid);
          this.followUpMessage = followup.data;
          this.followUpMessage.actionstatus = fmessage.actionstatus;
          if (followup.data[0].hasOwnProperty('answer')) {
            this.firstAnswer = followup.data[0].answer;
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getPreviousFollowUpQuestion() {
      if (!this.followUpMessage.length || this.followUpMessage[0].id === 1) {
        this.close()
      } else {
        this.composite = false;
        this.followUpAnswers = [];
        this.secondQuestionBody = {};
        const res = await ChatService.getPreviousFollowUpQuestion(
          this.followUpID,
          this.followUpMessage[0].id
        );
        if (res.data) {
          this.followUpMessage = res.data;
          if (res.data.length > 1) {
            this.composite = true;
            this.firstAnswer = res.data[0].answer;
            this.secondQuestionBody = res.data[1];
          }
        }
      }
    },
    async answerQuestion(id, answer, answerBody = null, moreQuestions, treatmentformanswer) {
      this.loadingQuestions = true;
      try {
        const messageid = this.followUpID;
        this.followUpAnswers = this.followUpAnswers.filter(o => o.questionid !== id);

        if (id == this.followUpMessage[0].id) {
          this.firstAnswer = answer;
        }

        if (answerBody?.inline) {
          this.followUpAnswers = [];
          this.composite = true;
          this.previousFollowUpID = id;
          const CompositeFollowUpRequest = await this.getFollowUpQuestion(messageid, answerBody.next);
          this.secondQuestionBody = CompositeFollowUpRequest.data[0];
          this.followUpAnswers.push({ questionid: id, answer: answer });
        } else {
          this.followUpAnswers.push({
            questionid: id,
            answer: answer,
            ...(moreQuestions && { others: [moreQuestions] }),
          });

          const rootID = this.followUpAnswers.length > 1 ? this.previousFollowUpID : id;
          const res = await this.answerFollowUpQuestion(messageid, rootID, { answers: this.followUpAnswers });
          this.currentFollowupStep = res.data.next;
          this.followUpAnswers = [];
          if (res.data.next !== -1) {
            if (answerBody?.type === 'treatmentform' && answerBody?.answerlist.length !== 0) {
              const treatmentFollowUpAnswer = [{ questionid: 11, answer: treatmentformanswer ? 'yes' : 'unsure' }];
              const questionresponse = await this.answerFollowUpQuestion(messageid, 11, { answers: treatmentFollowUpAnswer });
              await this.setFollowUpMessage(this.followUpID, questionresponse.data.next);
              this.currentFollowupStep = questionresponse.data.next;
              return
            }
            await this.setFollowUpMessage(this.followUpID, res.data.next);
          }
          this.loadingQuestions = false;
        }
      } catch (error) {
        this.error = error
      } finally {
        this.loadingQuestions = false;
      }
    },
    async submitNPS() {
      if (this.selectedRating) {
        AnalyticsService.submitNPSSurveyResponse(this.selectedRating);
      }

      this.close();
    },
    close(){
      this.$refs.modalv5.$children[0].hide();
    },
    open(){
      this.checkFollowupId();
      this.getConversation();
    }
  }
}
</script>
<style lang="scss" scoped>
.vs__dropdown-toggle {
  height: 52px;
}

.checkbox-label a {
  cursor: pointer;
  color: #a783ff;
  text-decoration: none;

  &:hover {
    color: #1a6a72 !important;
  }
}
</style>
